import CacheQuery from './CacheQuery';
import { REFRESH_MINIMUM } from './constants';

export default CacheQuery;
export { REFRESH_MINIMUM };
